import { render, staticRenderFns } from "./referenceAnswer.vue?vue&type=template&id=1e26d8e3"
import script from "./referenceAnswer.vue?vue&type=script&lang=js"
export * from "./referenceAnswer.vue?vue&type=script&lang=js"
import style0 from "./referenceAnswer.vue?vue&type=style&index=0&id=1e26d8e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports